/**
 * Guardar preferencias de la persona en el navegador (por ejemplo, si prefiere ver el tablero o la lista).
 *
 * El navegador puede negar el acceso (ventana privada, datos bloqueados): en ese caso las
 * preferencias simplemente no se recuerdan, pero la aplicación sigue funcionando igual.
 */

export function leerPreferencia(clave: string): string | null {
  try {
    return window.localStorage.getItem(`tablero-${clave}`);
  } catch {
    return null;
  }
}

export function guardarPreferencia(clave: string, valor: string): void {
  try {
    window.localStorage.setItem(`tablero-${clave}`, valor);
  } catch {
    // Sin almacenamiento disponible: se ignora a propósito.
  }
}
